import React, { useState, useEffect } from "react";
const logo = process.env.PUBLIC_URL + "/assets/logo.png";

export default function Nav({ onEstimate }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState("home");

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const sections = ["home", "services", "commitment", "clients", "about", "contact", "blog"];

  // Smooth scroll without # in URL
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      window.history.replaceState(null, "", window.location.pathname);
    }
    closeMenu();
  };

  // Active menu highlight using section boundaries
  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY + window.innerHeight / 3; // offset by 1/3 viewport height
      let current = "home";

      for (let i = 0; i < sections.length; i++) {
        const sec = sections[i];
        const el = document.getElementById(sec);
        if (el) {
          const top = el.offsetTop;
          const bottom = top + el.offsetHeight;
          if (scrollPos >= top && scrollPos < bottom) {
            current = sec;
            break;
          }
        }
      }

      setActive(current);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // initialize on load
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="header">
      <div className="container nav-inner">
        {/* Logo */}
        <div
          className="logo"
          onClick={() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            window.history.replaceState(null, "", window.location.pathname);
          }}
          style={{ cursor: "pointer" }}
        >
          <img src={logo} alt="Longrange Security Logo" />
          <h2 style={{ color: "#0a0f29" }}>Longrange Security</h2>
        </div>

        {/* Hamburger Menu */}
        <div className="hamburger" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Nav Links */}
        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          {sections.map((sec) => (
            <a
              key={sec}
              onClick={() => scrollToSection(sec)}
              style={{
                cursor: "pointer",
                color: active === sec ? "#ff6600" : "var(--navy)",
                fontWeight: active === sec ? 700 : 600,
              }}
            >
              {sec.charAt(0).toUpperCase() + sec.slice(1)}
            </a>
          ))}
          <button
            className="cta"
            onClick={() => {
              onEstimate();
              closeMenu();
            }}
          >
            Request Estimate
          </button>
        </nav>
      </div>
    </header>
  );
}
